import React, { useEffect } from 'react'
import { Dispatch } from 'redux'
import { Formik } from 'formik'
import { PackType } from '../../types/pack'
import { IDatafile } from '../../types/datafile'
import { ICapabilitiesSummary } from '../../types/capabilitiesSummary'
import { push } from '../../actions/router'
import { createDatafile } from '../../actions/datafile'
import {
  transformToDatafileFormat,
  defaultDataFileFormInputs,
} from '../../services/datafile'
import { getAllowedCapability } from '../../services/capabilitiesSummary'
import { DataFileForm } from '../DataFileForm'
import { dataFileValidationSchema } from './validation'

export interface ICreateDataFileForm {
  pack: PackType
  capabilitiesSummary?: ICapabilitiesSummary
  datafile: IDatafile
  packFormDirty?: boolean
  dispatch: Dispatch
}

export const CreateDataFileForm = ({
  pack,
  capabilitiesSummary,
  datafile,
  packFormDirty = false,
  dispatch,
}: ICreateDataFileForm) => {
  useEffect(() => {
    const { showDataFile } = getAllowedCapability(capabilitiesSummary)
    if (!showDataFile && !!pack.id) {
      dispatch(
        push(
          `/group/${pack.group}/pack/${pack.id}?edition=overall-pack&tab=details`
        )
      )
    }
  }, [pack.editionTypes, pack.id, pack.group, capabilitiesSummary, dispatch])

  return !pack.isLoading ? (
    <Formik
      initialValues={defaultDataFileFormInputs}
      onSubmit={(values) => {
        if (pack.id) {
          dispatch(
            createDatafile(pack.id, transformToDatafileFormat(values, true))
          )
        }
      }}
      render={(formikProps) => (
        <DataFileForm
          formikProps={formikProps}
          datastream={datafile.datastream}
          dataStreamError={datafile.dataStreamError}
          cancelAction={() => {
            formikProps.resetForm()
            dispatch(
              push(
                `/group/${pack.group}/pack/${pack.id}?edition=overall-pack&tab=upload`
              )
            )
          }}
          isFormDisabled={packFormDirty}
          packFormDirty={packFormDirty}
        />
      )}
      validationSchema={dataFileValidationSchema}
    />
  ) : null
}
